import React from 'react';
import { number, string } from 'prop-types';
import classNames from 'classnames';
function ProgressBar({
  className,
  percentage,
  progressBarClassName
}) {
  const wrapperClasses = classNames(className, {
    'pds-progress-bar-wrapper': true
  });
  const progressBarClasses = classNames(progressBarClassName, {
    'pds-progress-bar': true
  });
  return /*#__PURE__*/React.createElement("div", {
    className: wrapperClasses
  }, /*#__PURE__*/React.createElement("div", {
    className: progressBarClasses,
    style: {
      width: `${percentage}%`
    }
  }));
}
ProgressBar.propTypes = {
  /**
   * Applies additional CSS classes to the outer wrapper element of the
   * ProgressBar (unfilled part of the container).
   */
  className: string,
  /**
   * A number used to represent the filled portion of the ProgressBar component.
   */
  percentage: number.isRequired,
  /**
   * Applies additional CSS classes to the inner element of the ProgressBar
   * (filled part of the container).
   */
  progressBarClassName: string
};
ProgressBar.defaultProps = {
  className: null,
  progressBarClassName: null
};
export default ProgressBar;